module.exports = new __parcel__URL__("BrickWorldFilmFestival.858e5420.jpeg").toString();